import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import ReactDOM from "react-dom/client";
import { QueryClient, defaultShouldDehydrateQuery, } from "@tanstack/react-query";
import { createAsyncStoragePersister } from "@tanstack/query-async-storage-persister";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import "./core/i18n";
import App from "./pages/App";
import WatchVideo from "./pages/WatchVideo";
import { WATCH_VIDEO } from "./constants/ui";
const persister = createAsyncStoragePersister({
    storage: window.localStorage,
});
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: WATCH_VIDEO.CACHE_TIMEOUT,
        },
    },
});
ReactDOM.createRoot(document.getElementById("reactRoot")).render(_jsx(_Fragment, { children: _jsx(PersistQueryClientProvider, { client: queryClient, persistOptions: {
            persister,
            maxAge: WATCH_VIDEO.CACHE_TIMEOUT,
            dehydrateOptions: {
                shouldDehydrateQuery: (query) => defaultShouldDehydrateQuery(query) && query.meta?.persist !== false,
            },
        }, children: _jsx(App, { children: _jsx(WatchVideo, {}) }) }) }));
